// removed by extract-text-webpack-plugin
module.exports = {"root":"AccountPage__root___16Ol1","canvas":"AccountPage__canvas___3oHfB"};